<template>
    <section class="title-section">
        <div class="content-max-width">

            <h1>{{ title }}</h1>

        </div>
    </section>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.title-section {
	padding: 20px 0;

    text-align: center;
	background: #ECECEC;

	@media (min-width: $mediumish) {
		padding: 40px 0;
	}

	h1 {
        margin: 0;
		font-size: 18px;
		font-weight: $font-bold;
		text-align: center;
		text-transform: uppercase;
		line-height: 21px;
		color: black;

		@media (min-width: $mediumish) {
			font-size: 30px;
			line-height: 36px;
		}
	}

}
</style>




// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PageTitle.vue